
















import {Component} from '@/shared/component';
import {AbstractSearchVue} from '@/components/Abstract/AbstractSearchVue';

import InputSearchEntity from '@/components/Input/SearchEntity.vue';
import CrudLongueursVenteFilter from '@/components/Crud/LongueursVente/Filter.vue';
import CrudLongueursVenteList from '@/components/Crud/LongueursVente/List.vue';

@Component({
	components: {
		CrudLongueursVenteFilter,
		CrudLongueursVenteList,
		InputSearchEntity,
	}
})
export default class CrudLongueursVenteSearch extends AbstractSearchVue {
	private filterComponent = CrudLongueursVenteFilter;
	private listComponent = CrudLongueursVenteList;
}
